import type { QueryClient } from "@tanstack/react-query";

const POLICY_QUERY_ROOTS = new Set([
  "device", "devices", "compiled", "rules", "wizard", "network",
  "schedule", "schedules", "dashboard", "dashboard-summary", "employees",
]);

/** UI cache invalidation only. Compilation and policy hashes remain server-owned. */
export function invalidatePolicyViews(client: QueryClient): Promise<void> {
  return client.invalidateQueries({
    predicate: (query) => POLICY_QUERY_ROOTS.has(String(query.queryKey[0])),
  });
}
